export default __webpack_public_path__ + "images/c37682566ec70a0253db12b0b1a1ad81.png";